import { combineReducers } from 'redux'
import dashBoardReducer from './modules/dashboard'
import deliveryReducer from './modules/delivery'
import eventReducer from './modules/event'
import groupReducer from './modules/group'
import orderReducer from './modules/order'
import userReducer from './modules/user'
import productReducer from './modules/product'
import categoryReducer from './modules/category'

const reducers = combineReducers({
  group: groupReducer,
  event: eventReducer,
  order: orderReducer,
  user: userReducer,
  delivery: deliveryReducer,
  dashBoard: dashBoardReducer,
  product: productReducer,
  category: categoryReducer,
})

export default (state, action) => reducers(state, action)
